import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const validateTokenGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const cpf = sessionStorage.getItem('recovery_cpf');

  if (!cpf) {
    return router.createUrlTree(['/forgot-password']);
  }
  return true;
};
